// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__elIgA","heading":"Partners_heading__MPb0k","content":"Partners_content__eToQb","images":"Partners_images__jb13j"};